import axios from 'axios';
import apiBaseUrl from '../../config/apiBaseUrl';
import { processApiResponse } from '../helper/processApiResponse';
export const careOrderBabyAPI = {
    Init(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/careOrderBaby/init`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
    Transfer(params, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/v2/client/careOrderBaby/transfer`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
};
